import type { GetCommunityPostsOutput } from "@api/rest/types-and-hooks";

export enum BasecampRole {
  ADMIN = "basecamp-admin",
  NOTIFICATIONS_ADMIN = "basecamp-notifications-admin",
  ENABLEMENT_ADMIN = "basecamp-enablement-admin",
  ENTERPRISE_ADMIN = "basecamp-enterprise-admin",
  CHAT_ADMIN = "basecamp-chat-admin",
}

export interface DigestSection {
  id: string;
  header: string;
  color: string;
  posts: GetCommunityPostsOutput[];
  collapsed: boolean;
}

export const SECTION_COLORS = ["#ff912d", "#519aa6", "#57ad56", "#d6a3e7"] as const;
export const POPULAR_ACCENT_COLOR = SECTION_COLORS[3];

export const DragItemType = { POST: "post", SECTION: "section" } as const;
